import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { t } from 'utils/translates';

class DeadlineTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.secondsToTime(this.props.secondsLeft),
      seconds: this.props.secondsLeft,
      andTimerDesc: this.props.andTimerDesc
        ? this.props.andTimerDesc
        : t('Время вышло')
    };
  }

  componentWillMount() {
    this.timer = 0;
    this.timer = setInterval(this.countDown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  secondsToTime = secs => {
    const hours = Math.floor(secs / (60 * 60));

    const divisorForMinutes = secs % (60 * 60);
    const minutes = Math.floor(divisorForMinutes / 60);

    const divisorForSeconds = divisorForMinutes % 60;
    const seconds = Math.ceil(divisorForSeconds);

    return {
      h: hours,
      m: _.padStart(minutes, 2, '0'),
      s: _.padStart(seconds, 2, '0')
    };
  };

  countDown = () => {
    const seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds
    });
    if (seconds < 1) {
      clearInterval(this.timer);
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.seconds > 0
          ? `${this.state.time.h}:${this.state.time.m}:${this.state.time.s}`
          : this.state.andTimerDesc}
      </React.Fragment>
    );
  }
}

DeadlineTimer.defaultProps = {
  andTimerDesc: undefined
};

DeadlineTimer.propTypes = {
  secondsLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  andTimerDesc: PropTypes.string
};

export default DeadlineTimer;



// WEBPACK FOOTER //
// ./src/components/Common/DeadlineTimer/DeadlineTimer.js